const SgiCodeMirrorEO = function () {
    return {
        desId: "EP_EO_UI_CODEMIRROR",
    }
}

export { SgiCodeMirrorEO };
export default SgiCodeMirrorEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiCodeMirrorEO.js